import { SearchQueryResponse } from '@app/interfaces/interfaces';
import { QueryRequest } from '@app/store/slices/userSlice';
import { httpApi } from './http.api';
import { IDealRoomCategory } from '@app/interfaces/deal-room-category';

const baseSlug = '/deal-room-categories';

export const getCategoryListWithPagination = async (queryPayload: QueryRequest): Promise<SearchQueryResponse> => {
  try {
    const { data } = await httpApi.get<SearchQueryResponse>(
      `${baseSlug}/queryCategoriesWithPagination?${new URLSearchParams(
        queryPayload as Record<string, string>,
      ).toString()}`,
    );
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getCategoryOptions = async (): Promise<IDealRoomCategory[]> => {
  try {
    const { data } = await httpApi.get<IDealRoomCategory[]>(`${baseSlug}/options`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const createCategory = async (payload: Partial<IDealRoomCategory>): Promise<IDealRoomCategory> => {
  try {
    const { data } = await httpApi.post<IDealRoomCategory>(`${baseSlug}`, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const updateCategory = async (id: string, payload: Partial<IDealRoomCategory>): Promise<IDealRoomCategory> => {
  try {
    const { data } = await httpApi.patch<IDealRoomCategory>(`${baseSlug}/${id}`, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const deleteCategory = async (id: string): Promise<undefined> => {
  try {
    const { data } = await httpApi.delete<undefined>(`${baseSlug}/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};
